module.exports = __webpack_public_path__ + "static/media/clock_course.99216171.png";